import { withCurrencyLogo } from '@pancakeswap/widgets-internal'
import { Currency } from '@pancakeswap/sdk'
import { CurrencyLogo } from '@/components/currency-logo'

// @ts-ignore
export default withCurrencyLogo<Currency>(CurrencyLogo)
